"use strict";
/**
 * Provide a series of type guard predicates that satisfies the input,
 * and a function that will resolve the value if it matches the type guard.
 *
 * This function is similar to `match`, but resolves 2 arguments input cases
 *
 * !Note: There is a big difference between `match` and `match2`
 * `match2` does not force you to provide all combinations, so it can return undefined,
 *  as return type mentions.
 *  There is technical and coding experience limitation. In order to make `match2` be strict as `match`,
 *  the use will have to provide all possible cases between first argument and the second one. But this is already
 *  cartesian product and it can get huge very easy. For 3x3 input, you get 9 combinations. And yes, you guessed it,
 *  for 4x4, 16 combinations. But in real world usually you need 4 combinations.
 *  But at the same moment it enforces you to satisfy entire input type in at least one of type guards. And this is
 *  what makes it different from `if else` statement.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.match2 = void 0;
// endregion
function match2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // @ts-expect-error
    return function (t, t2) {
        for (var i = 0; i < args.length; i++) {
            if (args[i][0](t) && args[i][1](t2)) {
                return args[i][2](t, t2);
            }
        }
    };
}
exports.match2 = match2;
